"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "PublicDataExportController", {
    enumerable: true,
    get: function() {
        return PublicDataExportController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _basesservice = require("~/services/bases.service");
const _models = require("~/models");
const _Jobs = require("~/interface/Jobs");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
const _catchError = require("~/helpers/catchError");
const _publicapilimiterguard = require("~/guards/public-api-limiter.guard");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let PublicDataExportController = class PublicDataExportController {
    async exportModelData(context, req, publicDataUuid, exportAs, options) {
        var _req_headers, _view_meta;
        const view = await _models.View.getByUUID(context, publicDataUuid);
        if (!view) _catchError.NcError.viewNotFound(publicDataUuid);
        if (view.type !== _nocodbsdk.ViewTypes.GRID && view.type !== _nocodbsdk.ViewTypes.KANBAN && view.type !== _nocodbsdk.ViewTypes.GALLERY && view.type !== _nocodbsdk.ViewTypes.CALENDAR && view.type !== _nocodbsdk.ViewTypes.MAP) _catchError.NcError.notFound('Not found');
        if (!await _models.View.verifyPassword(view, (_req_headers = req.headers) == null ? void 0 : _req_headers['xc-password'])) {
            _catchError.NcError.invalidSharedViewPassword();
        }
        // check if download is allowed
        if (!((_view_meta = view.meta) == null ? void 0 : _view_meta.allowCSVDownload)) {
            _catchError.NcError.forbidden('Download is not allowed for this view');
        }
        if (!view) _catchError.NcError.viewNotFound(publicDataUuid);
        const job = await this.jobsService.add(_Jobs.JobTypes.DataExport, {
            context,
            options: _extends({}, options != null ? options : {}, {
                // includeByteOrderMark when export is triggered from controller
                includeByteOrderMark: true
            }),
            modelId: view.fk_model_id,
            viewId: view.id,
            user: req.user,
            exportAs,
            ncSiteUrl: req.ncSiteUrl
        });
        return {
            id: job.id
        };
    }
    constructor(jobsService, basesService){
        this.jobsService = jobsService;
        this.basesService = basesService;
    }
};
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/public/export/:publicDataUuid/:exportAs'
    ]),
    (0, _common.HttpCode)(200),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('publicDataUuid')),
    _ts_param(3, (0, _common.Param)('exportAs')),
    _ts_param(4, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], PublicDataExportController.prototype, "exportModelData", null);
PublicDataExportController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_publicapilimiterguard.PublicApiLimiterGuard),
    _ts_param(0, (0, _common.Inject)('JobsService')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService,
        typeof _basesservice.BasesService === "undefined" ? Object : _basesservice.BasesService
    ])
], PublicDataExportController);
